// @format
export class Billing {
  balance: number = -1;
  thisMonthCharges: number = -1;
  billingRecords: number = -1;
  monthlyChargesStorage: number = -1;
  monthlyChargesEUTraffic: number = -1;
  monthlyChargesUSTraffic: number = -1;
  monthlyChargesASIATraffic: number = -1;
  monthlyChargesSATraffic: number = -1;
}
